import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

// axios
import axios from 'axios'
Vue.prototype.$http = axios
Vue.prototype.CancelToken = axios.CancelToken;

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// Session
import VueSession from 'vue-session'
var options = {
  persist: true
}
Vue.use(VueSession, options)

// vue-json-excel

import JsonExcel from 'vue-json-excel'
Vue.component("JsonExcel", JsonExcel);

// v-viewer

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

// v-mask
import VueMask from 'v-mask'
Vue.use(VueMask)




// Custom Loading Spinner Component

import LoadingSpinner from '@/components/LoadingSpinner.vue'
Vue.component("loading-spinner", LoadingSpinner);

// Custom Overlay Loading Spinner Component

import OverlayLoading from '@/components/OverlayLoading.vue'
Vue.component("overlay-loading", OverlayLoading);

// Custom Card Skeleton Loading Component
import CardSkeletonLoading from '@/components/CardSkeletonLoading.vue'
Vue.component("card-skeleton-loading", CardSkeletonLoading);

// Custom Table Skeleton Loading Component
import TableSkeletonLoading from '@/components/TableSkeletonLoading.vue'
Vue.component("table-skeleton-loading", TableSkeletonLoading);

// Custom Article Skeleton Loading Component
import ArticleSkeletonLoading from '@/components/ArticleSkeletonLoading.vue'
Vue.component("article-skeleton-loading", ArticleSkeletonLoading);


// Blank Layout Component

import BlankLayout from "@/layouts/BlankLayout.vue";
Vue.component("blank-layout", BlankLayout);

// Default Layout Component
import DefaultLayout from "@/layouts/DefaultLayout.vue";
Vue.component("default-layout", DefaultLayout);


Vue.use(VueViewer)

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
